/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegisterRequest } from '../../models/register-request';
import { RegisterResult } from '../../models/register-result';

export interface PostRegister$Params {
  body?: RegisterRequest;
}

export function postRegister(
  http: HttpClient,
  rootUrl: string,
  params?: PostRegister$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RegisterResult>> {
  const rb = new RequestBuilder(rootUrl, postRegister.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RegisterResult>;
    }),
  );
}

postRegister.PATH = '/Registration/register';
